import { getArticle } from "#scripts/cmsapi.js";

export default async () => {
	const clientid = window.serverdata.configMeta.aim.clientId;
	const contentId = window.serverdata.configMeta.aim.frontpage;

	const html = await getArticle(contentId, clientid);
	document.getElementById("result__loadfrontpage")?.insertAdjacentHTML("beforeend", html);
};
